import React from "react";
import { formatValidInput } from "../../helpers/FormatHelper";
import NumberInput from "../shared/NumberInput";
import { Checkbox } from "antd";
import { useState } from "react";
import { useEffect } from "react";

export function OrderInformationDenomination({rowKey, denominations, currencyID, onBlurDenominationValue, valid, mixedNotes, lockedSide, onUpdateMixedNotes}){

     const [localValues, setLocalValues] = useState([]);

    useEffect(()=>{

    const values = [];
    denominations.forEach((d)=>{
        values.push(d.NoNotes);
    });
    setLocalValues(values);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[mixedNotes, currencyID])

    const onChangeDenominationValue =(value, index)=>{
        //onUpdateDenominationValue(value, index);
        value = value??0;
        const values = localValues;
        localValues[index] = Number(value);
        setLocalValues(values);
    }

    const onBlurDenomination = ()=>{
        onBlurDenominationValue(localValues);
    }

    const getDenominations = () =>{

    const listDenominations = [];
    listDenominations.push(<td>{lockedSide.toLowerCase() === 'sell' && <Checkbox id={`orderden-check-${rowKey}`} key={`orderden-check-${rowKey}`} checked={mixedNotes} onChange={(e)=>onUpdateMixedNotes(e.target.checked)} >{'Mixed Notes'}</Checkbox>}</td>)
    if(denominations)
    {
    denominations.forEach((d, index)=>{
        listDenominations.push(<td id={`orderden-${rowKey}-${index}`} key ={`orderden-${rowKey}-${index}`} >
          <label className="uk-form-label" style={{marginRight:'5px'}} htmlFor={`den-${rowKey}-${index}`}>{`${d.DenominationDescription} x `}</label>
          <NumberInput id={`den-${rowKey}-${index}`} className={`uk-denomination ${formatValidInput(d.valid && valid)}`} value={localValues[index] > 0 ? localValues[index] :''}
                      onBlur={onBlurDenomination} onChange ={(event) => {onChangeDenominationValue(event.target.value, index);}} scale={0} disabled={mixedNotes}/>
        </td>)
    })}

    return listDenominations;
 }

    return <table>
        <tr>
            {getDenominations()}
        </tr>
    </table>
}

export default OrderInformationDenomination